angular.module('app').controller('BarcodeChoiceCtrl', function($scope, $rootScope, $mdDialog, $interval, $http) {
    var main = this;
    $scope.choice = 'class';
    $scope.break = false;
    $scope.queueCheck = false;

    $scope.openDialog = function(){
        $rootScope.util.quickDialog(
            'BarcodeChoiceCtrl',
            'barcode-choice.html',
            {'id': main.id}
        );
    };

    $scope.download = function() {
        $http.post(
            '/api/v1/admin/event/' + main.id + '/barcode-report',
            {'sort': $scope.choice, 'break': $scope.break}
        ).then(function(response) {
            $scope.queueCheck = $interval(() => {
                $http.get(`/api/v1/admin/job/${response.data.job_id}/status`).then(
                    function(checkResponse) {
                        $scope.status = checkResponse.data.status;
                        if($scope.status == 'complete') {
                            top.location = response.data.filename;
                            $interval.cancel($scope.queueCheck);
                            $mdDialog.hide();
                        }
                    },
                    function() {
                        $rootScope.util.toast('There was an error generating your report. Please try again.');
                        $interval.cancel($scope.queueCheck);
                        $scope.queueCheck = false;
                    }
                );
            }, 3000)
        });
    };

    $scope.cancel = function() {
        if($scope.queueCheck) {
            $interval.cancel($scope.queueCheck);
        }
        $mdDialog.hide();
    }
});
